export var sortByTimestamp = function (order) {
    if (order === void 0) { order = 'asc'; }
    return function (a, b) {
        if (order !== 'asc') {
            return b.timestamp - a.timestamp;
        }
        return a.timestamp - b.timestamp;
    };
};
export var sortRecentFirst = sortByTimestamp('desc');
export var sortRecentLast = sortByTimestamp('asc');
//# sourceMappingURL=sortByTimestamp.js.map